import React from "react";
import { GOVGR_HEADING_S } from "../../conf/styles/GovGrSelect";
import imageLock from "../icons/lock.png";

const Label = ({ label, disabled }) => {
  return (
    <div className="flex content-center h-5">
      <span role="heading" aria-level="1" className={`${GOVGR_HEADING_S}`}>
        {label}
      </span>
      {disabled && (
        <img
          src={imageLock}
          className="ml-1 object-contain"
          alt="lock"
          width="21px"
        />
      )}
    </div>
  );
};

export default Label;
